import DOMPurify from 'dompurify';

/**
 * Sanitizes a string input using DOMPurify to prevent XSS.
 * Configuration allows common text formatting but strips scripts and dangerous attributes.
 */
export const sanitizeInput = (input: string): string => {
  if (typeof input !== 'string') return input;
  
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [], // Strip all HTML tags for standard text inputs
    ALLOWED_ATTR: [], // No attributes allowed
    KEEP_CONTENT: true, // Keep the text content
  });
};

/**
 * Sanitizes HTML content where basic formatting might be allowed (e.g. notes).
 * Currently configured to strip everything to be safe, but can be extended.
 */
export const sanitizeHtml = (input: string): string => {
    if (typeof input !== 'string') return input;
    return DOMPurify.sanitize(input);
};
